"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultType = void 0;
/**
 * The result type enum
 */
var ResultType;
(function (ResultType) {
    ResultType["Auto"] = "Auto";
    ResultType["StableFragment"] = "StableFragment";
    ResultType["Hypothesis"] = "Hypothesis";
    ResultType["None"] = "None";
})(ResultType = exports.ResultType || (exports.ResultType = {}));

//# sourceMappingURL=InterimResults.js.map
